import React from "react";
import { Jumbotron } from "./migration";
import { Container } from "react-bootstrap";
import { useState } from "react";

const Experience = ({ experiences }) => {
  const [expandedMap, setExpandedMap] = useState({});

  const toggleExpanded = (i) => {
    setExpandedMap((prev) => ({ ...prev, [i]: !prev[i] }));
  };

  const truncate = (text, limit = 220) => {
    if (!text) return "";
    if (text.length <= limit) return text;
    return text.slice(0, limit) + "...";
  };

  return (
    <section className="section">
      <Container>
        <Jumbotron className="bg-white experience-section">
          <h2 className="display-5 mb-4">Experience</h2>

          <div className="experience-list">
            {experiences.data.map((item, index) => {
               const isMostRecent = index === 0;
               const isLast = index === experiences.data.length - 1;
               const company = item.company || "Company name";
               const companyLogo = item.logoUrl || null;
               const role = item.title || "Job title";
              // stable key for expansion state (avoids index-related issues)
              const itemKey = `${company}-${role}-${item.dateRange || index}`;
               const employmentType = item.employmentType || "Full-time";
               const totalDuration = item.totalDuration || "3 yrs 2 mos";
               const dateRange =
                 item.dateRange || "Jan 2022 – Present · 2 yrs";
               const location = item.location || "City, State, Country";
               const workMode = item.workMode || "On-site";

               const summary =
                 item.summary ||
                 "Short one‑line summary about your role impact and scope of work.";
               const description =
                 item.description ||
                 "Write 2–3 lines describing the key responsibilities, major projects, and business impact you delivered in this role.";

               const skillsSummary =
                 item.skillsSummary || "Cloud, Data Engineering and +5 skills";

               return (
                <div className="experience-row" key={index}>
                  {/* Timeline column */}
                  <div className="experience-timeline-col">
                    {!isMostRecent && <div className="experience-line-top" />}
                    <div
                      className={
                        "experience-dot" +
                        (isMostRecent ? " experience-dot-active" : "")
                      }
                    />
                    {!isLast && <div className="experience-line-bottom" />}
                  </div>

                  {/* Card column */}
                  <div className="experience-card-col">
                    {/* Company header (logo + name + total tenure) */}
                    {index === 0 && (
                      <div className="experience-company-header">
                        {companyLogo ? (
                          <div className="logo-wrapper header">
                            <img src={companyLogo} alt={company} className="experience-company-logo-image" />
                          </div>
                        ) : (
                          <div className="logo-wrapper header placeholder">
                            <span>{company[0]}</span>
                          </div>
                        )}
                        <div>
                          <h3 className="experience-company-name">
                            {company}
                          </h3>
                          <p className="experience-company-meta">
                            {employmentType} · {totalDuration}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Role block */}
                    <div className="experience-role-block">
                      {/* Small logo for non-header entries */}
                      {index !== 0 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                          {companyLogo ? (
                            <div className="logo-wrapper small">
                              <img src={companyLogo} alt={company} className="experience-company-logo-image" />
                            </div>
                          ) : (
                            <div className="logo-wrapper small placeholder">
                              <span style={{ fontWeight: 600 }}>{company[0]}</span>
                            </div>
                          )}
                           <div>
                             <div style={{ fontSize: 14, fontWeight: 600 }}>{company}</div>
                             <div style={{ fontSize: 12, color: '#666' }}>{employmentType} · {totalDuration}</div>
                           </div>
                         </div>
                       )}

                      <h4 className="experience-role-title">{role}</h4>
                      <p className="experience-role-meta">
                        {dateRange}
                        <span className="dot-separator">·</span>
                        {location}
                        <span className="dot-separator">·</span>
                        {workMode}
                      </p>

                      <p className="experience-role-summary">{summary}</p>

                      <p className="experience-role-description">
                        {expandedMap[itemKey] ? description : truncate(description)}
                      </p>

                      {description && description.length > 220 && (
                        <button
                          type="button"
                          className="experience-see-more-btn"
                          onClick={() => toggleExpanded(itemKey)}
                          aria-expanded={!!expandedMap[itemKey]}
                        >
                          {expandedMap[itemKey] ? "See less" : "…see more"}
                        </button>
                      )}

                      <div className="experience-skills-row">
                        <span className="experience-skill-pill">
                          {skillsSummary}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Jumbotron>
      </Container>
    </section>
  );
};

export default Experience;

